import { SignJWT } from "jose";

const SECRET_KEY = new TextEncoder().encode("shared_secret_here");

export async function generateMikrotikToken({
  host,
  username,
  password,
}: {
  host: string;
  username: string;
  password: string;
}) {
  return await new SignJWT({
    host,
    username,
    password,
  })
    .setProtectedHeader({ alg: "HS256" })
    .sign(SECRET_KEY);
}

export function saveMikrotikToken(token: string) {
  localStorage.setItem("mikrotikToken", token);
}

export function clearMikrotikToken() {
  localStorage.removeItem("mikrotikToken");
}
